import mixpanel from 'mixpanel-browser';
import api from '../../../lib/api';

const mixToken = process.env.VUE_APP_MIXPANEL_TOKEN;
mixpanel.init(mixToken);

export default {
  async getCompanyById({ commit }, id) {
    const payload = await api.company.getCompanyById(id);

    commit('setValues', payload);

    commit(
      'invoice/setValues',
      {
        emitterRfc: payload.rfc,
        emitterName: payload.name,
        emitterRegime: payload.regime,
      },
      { root: true },
    );

    return payload;
  },

  async updateCompany({ commit, state, rootState }, id) {
    const {
      tradeName,
      password,
      name,
      cer,
      key,
      logoPdf,
      regime,
      rfc,
      zipCode,
      curp,
      employerRegistration,
      ciec,
    } = state;

    const formData = new FormData();
    if (tradeName) formData.append('tradeName', tradeName);
    if (password) formData.append('password', password);
    if (regime) formData.append('regime', regime);
    if (name) formData.append('name', name);
    if (key) formData.append('key', key);
    if (cer) formData.append('cer', cer);
    if (logoPdf) formData.append('logoPdf', logoPdf);
    if (rfc) formData.append('rfc', rfc);
    if (zipCode) formData.append('zipCode', zipCode);
    if (curp) formData.append('curp', curp);
    if (employerRegistration) formData.append('employerRegistration', employerRegistration);
    if (ciec) formData.append('ciec', ciec);

    const payload = await api.company.updateCompany(id, formData);

    commit('setValues', {
      ...payload,
      haveEfirma: true,
      zipCode,
    });

    if (key && cer) {
      mixpanel.track('Carga archivos CSD', {
        distinct_id: rootState.auth.subscriberId || rootState.company.rfc,
      });
    }

    return payload;
  },

  async saveCompany({ commit, state }) {
    const {
      tradeName,
      password,
      name,
      cer,
      key,
      logoPdf,
      regime,
      rfc,
      zipCode,
      curp,
      employerRegistration,
      ciec,
    } = state;

    const formData = new FormData();

    if (tradeName) formData.append('tradeName', tradeName);
    if (password) formData.append('password', password);
    if (regime) formData.append('regime', regime);
    if (name) formData.append('name', name);
    if (key) formData.append('key', key);
    if (cer) formData.append('cer', cer);
    if (logoPdf) formData.append('logoPdf', logoPdf);
    if (rfc) formData.append('rfc', rfc);
    if (zipCode) formData.append('zipCode', zipCode);
    if (curp) formData.append('curp', curp);
    if (employerRegistration) formData.append('employerRegistration', employerRegistration);
    if (ciec) formData.append('ciec', ciec);

    const payload = await api.company.saveCompany(formData);

    commit('setValues', payload);

    commit('auth/setValue', {
      accessor: 'companyId',
      value: payload.id,
    }, { root: true });

    commit(
      'auth/setValue',
      { accessor: 'haveEfirma', value: true },
      { root: true },
    );

    return payload;
  },
};
